// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_Qz9","rootMobile":"styles_rootMobile__1hIXh"};